import { gql } from "@apollo/client/core";

// Several flow keys in one round trip: the platform review reads its once row, its "Not now" row and
// its per-showing rows together. Same select permission as GetUserWelcomeFlowQuery (own rows, any tenant).
const GetUserWelcomeFlowRowsQuery = gql`
  query GetUserWelcomeFlowRows($flowKeys: [String!]!) {
    userWelcomeFlow(where: { flowKey: { _in: $flowKeys } }) {
      userId
      flowKey
      variant
      seenAt
      completedAt
    }
  }
`;

export default GetUserWelcomeFlowRowsQuery;
